export const colum = [
  {
    label: "STT",
    key: "stt",
    align: 'center',
    width: '5%'
  },
  {
    label: "Hình ảnh",
    key: "avatar",
    align: 'center',
  },
  {
    label: "Tên nhân viên",
    key: "name",
  },
  {
    label: "Tên phòng ban",
    key: "department",
  },
  {
    label: localStorage?.getItem("role")?.split(",")?.some(r => r === "A") ? "Đơn vị" : "",
    key: localStorage?.getItem("role")?.split(",")?.some(r => r === "A") ? "organization_name" : '',
    align: 'left',
  },
  {
    label: "Thời gian",
    key: "time",
    align: 'center',
  },
  {
    label: "Hành động",
    key: "action",
    align: 'center',
  },
];